import { UserRoles } from "common/enums";
import Faqs from "components/faqs";
import * as appRoutes from "config/routes.config";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AnimatedPage from "utils/animatedPage";
import Advantages from "./components/advantages";
import ContactUs from "./components/contactUs";
import InstaProf from "./components/instaProf";
import JoinCommunity from "./components/joinCommunity";
import OurPlateforme from "./components/plateforme";
import SlideTeacher from "./components/slide";
import TeachersTestimonies from "./components/testimonies";

const ProfesseurPage = () => {

    //!HOOKS
    const { t } = useTranslation();
    const auth = useSelector((state) => state.auth);
    const { isAppInMaintenance } = useSelector((state) => state.auth);
    const navigate = useNavigate();

    //!EFFECTS
    useEffect(() => {
        const isLoggedIn = auth.isLoggedIn;
        const isTeacher = auth.user?.roles?.includes(UserRoles.TEACHER);
        const isStudent = auth.user?.roles?.includes(UserRoles.STUDENT);
        if (isLoggedIn && isTeacher) return navigate(appRoutes.TEACHER_ACTIVITIES);
        if (isLoggedIn && isStudent) return navigate(appRoutes.TEACHER_ACTIVITIES);
    }, [auth.isLoggedIn, navigate, auth.user?.roles]);

    useEffect(() => {
        if (isAppInMaintenance) {
            navigate(appRoutes.MAINTENANCE);
        };
    }, [isAppInMaintenance]);

    return (
        <AnimatedPage>
            <SlideTeacher />
            <Advantages />
            <OurPlateforme />
            <InstaProf />
            <Faqs type={"teacher"} />
            <JoinCommunity />
            <TeachersTestimonies />
            <ContactUs from="teacher" />
        </AnimatedPage>
    );
};

export default ProfesseurPage;
